/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import FAQ from 'pagesNew/FAQ'
import { FaqPages } from '__generatedTypes__/globalTypes'
import { PATGeneratorsTabs } from './consts'
import * as classes from './styles'
import { DescriptionContent } from './DescriptionContent'

const tabs = Object.values(PATGeneratorsTabs).map((item) => ({ id: item, title: item }))

const PATGenerators: FC = () => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === PATGeneratorsTabs.FAQ) {
      return <FAQ page={FaqPages.PATGenerators} />
    }

    if (title === PATGeneratorsTabs.DESCRIPTION) {
      return <DescriptionContent />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        PAT Generators
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}

export default PATGenerators
